// --------------------- Import Antd-Design ---------------------
import { Card, Form, Input, Modal, Radio, Skeleton, Typography } from "antd";
import { Parceiro } from "../../../interfaces/Parceiro";
import { useEffect, useState } from "react";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { layout } from "../styles";
import { useCadastrarParceiro } from "../hooks/useCadastrarParceiro";
import { useParceiro } from "../hooks/useParceiro";
import { useAtualizarParceiro } from "../hooks/useAtualizarParceiro";

interface ModalProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  parcerioId: number;
  buscar: () => void;
}

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  parcerioId,
  buscar,
}: ModalProps) {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const [formEditarParceiro] = Form.useForm();

  // Chamada da função para buscar o parceiro
  const { parceiro, isLoading } = useParceiro(isModalOpen, parcerioId);

  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetError,
    resetSuccess,
  } = useAtualizarParceiro();

  // Estado inicial dos dados Parceiro que sera criado
  const [parceiroData, setParceiroData] = useState<Parceiro>({
    nome: "",
    descricao: "",
    active: 1,
  });

  // Função que armazena os dados alterados de Apartamento
  const parceiroChange = (changedValues: Parceiro, allValues: Parceiro) => {
    setParceiroData(allValues);
  };

  // Exibe a Mensagem
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
        buscar();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    showSuccess,
    resetSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() => atualizar(parcerioId, parceiroData)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          },
        }}
      >
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Card
            title={<Title>Editar Parceiro</Title>}
            style={{
              width: "100%",
              marginTop: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {contextHolder}
            <Form
              {...layout}
              form={formEditarParceiro}
              onValuesChange={(changedValues, allValues) =>
                parceiroChange(changedValues, allValues)
              }
              name="editar-parceiro-form"
              initialValues={parceiro}
            >
              <Form.Item
                name="nome"
                label="Nome Parceiro"
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="descricao"
                label="Descrição Parceiro"
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="active"
                label="Ativar/Desativar "
                className="formItems"
              >
                <Radio.Group
                // onChange={possuiVarandaChange}
                // value={possuiVaranda}
                >
                  <Radio value={0}>Desativar</Radio>
                  <Radio value={1}>Ativar</Radio>
                </Radio.Group>
              </Form.Item>
            </Form>
          </Card>
        )}
      </Modal>
    </>
  );
}
